import { Phone, MessageCircle } from "lucide-react";
import { SITE, waLink } from "../../data/site";

export default function FloatingActions() {
  return (
    <div className="no-print fixed bottom-5 right-5 z-40 flex flex-col gap-3">
      <a
        data-testid="fab-whatsapp"
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="grid place-items-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 hover:scale-110 transition-transform"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        data-testid="fab-call"
        href={`tel:${SITE.phoneDial}`}
        aria-label="Call us"
        className="grid place-items-center w-14 h-14 rounded-full bg-brand-blue text-white shadow-lg shadow-brand-blue/40 hover:scale-110 transition-transform"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
}
